function DoctorsLoader() {
  return (
    <div className="flex items-center gap-2">
      <div className="mb-2 h-20 w-16 min-w-16 max-w-16 animate-pulse rounded-lg bg-gray-400" />
      <div className="w-full">
        <div className="flex items-center justify-between gap-2">
          <div className="mb-2 h-4 w-[60%] animate-pulse rounded-md bg-gray-400" />
          <div className="mb-2 h-6 w-16 animate-pulse rounded-md bg-gray-400" />
        </div>
        <div className="mb-2 h-4 w-[40%] animate-pulse rounded-md bg-gray-400" />
      </div>
    </div>
  );
}

export default DoctorsLoader;
